// Follow toggle for the position button. Pure state machine; geolocate.mjs runs the effects.
// off: nothing; centering: one-shot jump on start; locating: waiting for the first fix to follow; on: map follows.
export const FOLLOW_STATES = ['off', 'centering', 'locating', 'on'];

export function followStep(state, event) {
  const busy = state === 'locating' || state === 'on';
  switch (event) {
    case 'tap': return busy ? {state: 'off', effects: ['stop']} : {state: 'locating', effects: ['watch']};
    case 'start-follow': return {state: 'locating', effects: ['watch']};
    case 'start-center': return state === 'off' ? {state: 'centering', effects: ['watch']} : {state, effects: []};
    case 'fix':
      if (state === 'locating') return {state: 'on', effects: ['marker', 'center']};
      if (state === 'on') return {state: 'on', effects: ['marker', 'follow']};
      if (state === 'centering') return {state: 'off', effects: ['marker', 'center', 'stop']};
      return {state: 'off', effects: ['marker']};
    case 'interaction': return state === 'off' ? {state, effects: []} : {state: 'off', effects: ['stop']};
    case 'error': return state === 'off' ? {state, effects: []} : {state: 'off', effects: ['stop', 'message']};
    default: return {state, effects: []};
  }
}

// Zoom buttons and the +/- keys zoom around the map centre, which is the position while following,
// so they keep follow mode. Everything else with an originalEvent (drag, pinch, wheel and double-click
// around the pointer, arrow keys) moves the centre and ends it. Programmatic moves have no originalEvent.
const ZOOM_CONTROLS = '.maplibregl-ctrl-zoom-in, .maplibregl-ctrl-zoom-out';
const ZOOM_KEYS = ['+', '=', '-', '_'];
export function keepsFollow(originalEvent) {
  if (!originalEvent) return true;
  if (originalEvent.target?.closest?.(ZOOM_CONTROLS)) return true;
  return originalEvent.type === 'keydown' && ZOOM_KEYS.includes(originalEvent.key)
    && !originalEvent.altKey && !originalEvent.ctrlKey && !originalEvent.metaKey;
}

// Turning follow on zooms in to the near level when the map is further out, never out.
export const NEAR_ZOOM = 15;
export const centerZoom = current => Math.max(current, NEAR_ZOOM);
